import { createFileRoute } from '@tanstack/react-router';
import { PeopleNewRouteView } from '@/pages/workspaces/people/routing';
import { LastWorkspaceResolver } from './-components';

/**
 * No `appBundle`: this URL has no `journeys` segment, and the bundle-aware
 * branch of the resolver rebuilds the target from the bundle prefix — which
 * would find no `/journeys/` here and land on the Journeys home instead.
 *
 * Both People segments render the page; the route view forwards the one the
 * account's taxonomy stage does not serve.
 */
function ProfilesNewRoute() {
  return (
    <LastWorkspaceResolver>
      <PeopleNewRouteView segment="profiles" />
    </LastWorkspaceResolver>
  );
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/profiles/new')({
  component: ProfilesNewRoute,
});
